import { createReducer } from '../../utils/misc'

import {
  FETCH_REGIONS_REQUEST,
  FETCH_REGIONS_SUCCESS,
  FETCH_COMMUNES_REQUEST,
  FETCH_COMMUNES_SUCCESS,
  FETCH_BANKS_REQUEST,
  FETCH_BANKS_SUCCESS,
  FETCH_CITYS_REQUEST,
  FETCH_CITYS_SUCCESS,
  ACTIVE_STEP,
  DEACTIVATE_STEP
} from '../constants/utils'

const initialState = {
  fetchingRegions: false,
  fetchingCommunes: false,
  fetchingBanks: false,
  fetchingCiudades: false,
  regions: [],
  communes: [],
  banks: [],
  ciudades: [],
  disabledStep: true
}
export default createReducer(initialState, {
  [FETCH_REGIONS_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingRegions: true
    }),
  [FETCH_REGIONS_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingRegions: false,
      regions: payload.regions
    }),
  [FETCH_COMMUNES_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingCommunes: true
    }),
  [FETCH_COMMUNES_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingCommunes: false,
      communes: payload.communes
    }),
  [FETCH_BANKS_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingBanks: true
    }),
  [FETCH_BANKS_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingBanks: false,
      banks: payload.banks
    }),
  [FETCH_CITYS_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingCiudades: true
    }),
  [FETCH_CITYS_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingCiudades: false,
      ciudades: payload.ciudades
    }),
  [ACTIVE_STEP]: (state) =>
    Object.assign({}, state, {
      disabledStep: false
    }),
  [DEACTIVATE_STEP]: (state) =>
    Object.assign({}, state, {
      disabledStep: true
    }),
})
